import { put, select } from 'redux-saga/effects'
import { selectGameAPIData } from '../selectors'
import * as actions from '../actions'
import { randomizeArray } from '../../../utils/util';


export function* getSequencingData(payload, getGameData) {
    const { from, steps } = payload;
    // The tasks in the language chosen (question_sp, step1_hi, audio_vi…; English has no ending), English where one is missing.
    const sfx = payload.language && payload.language !== 'en' ? `_${payload.language}` : ''
    const pick = (item, field) => item[`${field}${sfx}`] || item[field]

    let sequencingState = yield select(selectGameAPIData)

    if (!sequencingState) {
        sequencingState = yield* getGameData(
            null,
            null,
            null,
            'SEQUENCING',
            from,
            null,
            null
        )

        yield put(actions.setGameData({ apiData: sequencingState }))
    }

    let resultItems = []

    sequencingState.filter(function (item) {
        if (steps === 3) {
            return item.step4 === null && item.step5 === null
        } else if (steps === 4) {
            return item.step4 !== null && item.step5 === null
        } else {
            return item.step4 !== null && item.step5 !== null
        }
    }).forEach((item) => {
        resultItems.push({
            id: item.id,
            audio: pick(item, 'audio'),
            audio_path: item.audio_path,
            gamelevel: item.gamelevel,
            question: pick(item, 'question'),
            steps: randomizeArray([
                ...[...Array.from({ length: steps }, (v, index) => {
                    return (
                        ({ id: index + 1, step: pick(item, `step${index + 1}`) })
                    )
                }
                )],
            ])
        })
    })
    const displayData = randomizeArray(resultItems)
    const metaFieldData = {
        activeItemIndex: 0,
        gameData: displayData,
        droppedAnswer: [],
        invisibleAnswerIds: [],
        questionsAnswered: [],
    }
    return { displayData, metaFieldData }
}